module.exports = __webpack_public_path__ + "img/fi-rr-globe-alt.0d2405b0.svg";